module.exports = __webpack_public_path__ + "static/twan-da-god.5079aeeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/twan-da-god.jpg
// module id = 1708
// module chunks = 173894859265406